export const QUALITY_TYPES = ['premium', 'medium', 'budget']

const getProductConfig = (qualityConfig, productType) => {
  return qualityConfig?.types?.[productType]
}

export const getVisibleQualityTypes = (qualityConfig, productType) => {
  const productConfig = getProductConfig(qualityConfig, productType)

  // Keep the current behavior for stores without an applicable quality config.
  if (!productConfig)
    return QUALITY_TYPES.slice()

  const configuredOrder = Array.isArray(qualityConfig.order)
    ? qualityConfig.order.filter(
      (type, index, types) =>
        QUALITY_TYPES.indexOf(type) !== -1 && types.indexOf(type) === index
    )
    : []
  const orderedTypes = configuredOrder.concat(
    QUALITY_TYPES.filter(type => configuredOrder.indexOf(type) === -1)
  )

  return orderedTypes.filter(type => productConfig[type]?.show === true)
}

export const getDefaultQualityTypes = (qualityConfig, productType) => {
  const productConfig = getProductConfig(qualityConfig, productType)
  if (!productConfig)
    return []

  return getVisibleQualityTypes(qualityConfig, productType)
    .filter(type => productConfig[type]?.default === true)
}

export const getSelectedQualityTypes = (quality, qualityConfig, productType) => {
  if (!quality)
    return getDefaultQualityTypes(qualityConfig, productType)

  const selectedTypes = Array.isArray(quality) ? quality : [quality]
  const visibleTypes = getVisibleQualityTypes(qualityConfig, productType)
  return selectedTypes.filter(type => visibleTypes.indexOf(type) !== -1)
}

export const getQualitySearchTypes = (selectedTypes, visibleTypes) => {
  return selectedTypes.length > 0 ? selectedTypes : visibleTypes
}
